import React from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import { CircularProgress } from '@material-ui/core';
import * as ROUTES from '@/constants/routes';
import { BannerButton, EmptyState, PageSurface } from './blocks';

/** The page shown in place of a shipper while it loads, or when the admin can't open it. */
const ShipperGate = ({ isPermitted, loading, error, shipper }) => {
    const navigate = useNavigate();

    if (!isPermitted) {
        return (
            <PageSurface>
                <EmptyState>
                    This shipper is not part of your organization.{' '}
                    <BannerButton
                        onClick={() => navigate(ROUTES.CORPORATE_USERS)}
                        css={css`
                            background: none;
                            border: none;
                            color: inherit;
                            text-decoration: underline;
                        `}
                    >
                        Back to Accounts
                    </BannerButton>
                </EmptyState>
            </PageSurface>
        );
    }

    let message = 'Shipper not found.';
    if (loading) message = <CircularProgress size={28} />;
    else if (error) message = "Couldn't load this shipper. Refresh to try again.";
    else if (shipper) return null;

    return (
        <PageSurface>
            <EmptyState>{message}</EmptyState>
        </PageSurface>
    );
};

export default ShipperGate;
